import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DeleteOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { MouseEvent } from "react"

interface ProductFileRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isOpen: boolean
  onViewDocument: (e: MouseEvent<HTMLLIElement>) => void
  onRemoveDocument: (e: MouseEvent<HTMLLIElement>) => void
}

export const ProductFileRowDropdownMenu: React.FC<ProductFileRowDropdownMenuProps> = ({
  anchorEl,
  isOpen,
  onClose,
  onViewDocument,
  onRemoveDocument,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose} data-test='product-file-row-dropdown-menu'>
      <MenuItem onClick={onViewDocument} data-test='product-file-edit-menu-item'>
        <ListItemIcon>
          <VisibilityOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='View Document' />
      </MenuItem>
      <MenuItem onClick={onRemoveDocument} data-test='product-file-update-status-menu-item'>
        <ListItemIcon>
          <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Delete Document' />
      </MenuItem>
    </Menu>
  )
}
